module.exports = __webpack_public_path__ + "img/rashid.27cc2c94.jpg";